import { ProductModel } from "../schema/product.model";
import { MongoBaseContainer } from "./mongo-base-container.model";

export class ProductContainer extends MongoBaseContainer{
    product: ProductModel;
}